enum RoutePath {
  Root = '',
  Error = 'error',
  DataPolicy = 'persondatapolitik',
  AboutUs = 'om-os'
}

export default RoutePath;
